// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2rzBF","calendarButtons":"ClockData_calendarButtons__1QHq_"};